import { ReportType } from "constants/reports/report-type";
import { ActionsUnion, createAction } from "store/helper";

import { RequestAction } from "../actions";

import {
  ICreateReportFailurePayload,
  ICreateReportPayload,
  ICreateReportSuccessPayload,
  IDeleteReportFailurePayload,
  IDeleteReportPayload,
  IDeleteReportSuccessPayload,
  IEditReportFailurePayload,
  IEditReportPayload,
  IEditReportSuccessPayload,
  IFetchReportFailurePayload,
  IFetchReportPayload,
  IFetchReportSuccessPayload,
} from "./interfaces";

type IReportActionNames = { [key in ReportType]: { [key in RequestAction]: string } };

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createSingleReportRequestTypeBase = (reportName: string) =>
  `ENTITIES/REPORT/FETCH_${reportName.replace(/-/g, "_").toUpperCase()}`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createSingleRequestTypes = (actionBase: string) =>
  [RequestAction.REQUEST, RequestAction.SUCCESS, RequestAction.FAILURE].reduce(
    (acc, type) => ({
      ...acc,
      [type]: `${actionBase}_${type}`,
    }),
    {}
  );

export const REPORT: IReportActionNames = Object.keys(ReportType).reduce(
  (acc, reportName) => ({
    ...acc,
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    [ReportType[reportName]]: createSingleRequestTypes(createSingleReportRequestTypeBase(ReportType[reportName])),
  }),
  {}
) as IReportActionNames;

export const CreateReportActionNames = createSingleRequestTypes("ENTITIES/REPORT/CREATE_REPORT");
export const EditScheduledReportActionNames = createSingleRequestTypes("ENTITIES/REPORT/EDIT_SCHEDULED_REPORT");
export const DeleteScheduledReportActionNames = createSingleRequestTypes("ENTITIES/REPORT/DELETE_SCHEDULED_REPORT");

export const ReportActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: (payload: IFetchReportPayload) =>
    REPORT[payload.reportType] ? createAction(REPORT[payload.reportType][RequestAction.REQUEST], payload) : null,

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchHeatMap: (payload: IFetchReportPayload) =>
    REPORT[payload.reportType] ? createAction(REPORT[payload.reportType][RequestAction.REQUEST], payload) : null,

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSuccess: <TData>(payload: IFetchReportSuccessPayload<TData>) =>
    createAction(REPORT[payload.reportType][RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchFailure: (payload: IFetchReportFailurePayload) =>
    createAction(REPORT[payload.reportType][RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createReport: (payload: ICreateReportPayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(CreateReportActionNames[RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createReportSuccess: (payload: ICreateReportSuccessPayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(CreateReportActionNames[RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createReportFailure: (payload: ICreateReportFailurePayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(CreateReportActionNames[RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  editScheduledReport: (payload: IEditReportPayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(EditScheduledReportActionNames[RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  editScheduledReportSuccess: (payload: IEditReportSuccessPayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(EditScheduledReportActionNames[RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  editScheduledReportFailure: (payload: IEditReportFailurePayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(EditScheduledReportActionNames[RequestAction.FAILURE], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteScheduledReport: (payload: IDeleteReportPayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(DeleteScheduledReportActionNames[RequestAction.REQUEST], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteScheduledReportSuccess: (payload: IDeleteReportSuccessPayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(DeleteScheduledReportActionNames[RequestAction.SUCCESS], payload),

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteScheduledReportFailure: (payload: IDeleteReportFailurePayload) =>
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    createAction(DeleteScheduledReportActionNames[RequestAction.FAILURE], payload),
};

export type ReportAction = ActionsUnion<typeof ReportActions>;
